import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { SERVICES } from "../data/services";
import ServiceCard from "../components/ServiceCard";
import TrustStrip from "../components/TrustStrip";
import BookingCTA from "../components/BookingCTA";
import FaqSection from "../components/FaqSection";

const ServicesIndex = () => {
    const { t } = useLanguage();

    return (
        <>
            <section
                data-testid="services-hero"
                className="bg-[#3D3D24] text-[#FFFFF3] py-28 md:py-36 relative overflow-hidden bink-grain"
            >
                <div className="relative max-w-[1400px] mx-auto px-6 z-10">
                    <div className="font-label text-[11px] text-[#D4A95A] mb-5">
                        {t.home.servicesOverline}
                    </div>
                    <h1 className="font-serif text-5xl md:text-7xl leading-[0.98] mb-7 max-w-3xl">
                        {t.home.servicesTitle}
                    </h1>
                    <p className="text-base md:text-lg opacity-85 max-w-2xl leading-relaxed">
                        {t.home.servicesSub}
                    </p>
                </div>
            </section>

            <TrustStrip variant="light" />

            <section
                data-testid="services-grid"
                className="bg-[#FFFFF3] py-24 md:py-32"
            >
                <div className="max-w-[1400px] mx-auto px-6">
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                        {SERVICES.map((s) => (
                            <ServiceCard
                                key={s.slug}
                                slug={s.slug}
                                serviceKey={s.key}
                                image={s.image}
                            />
                        ))}
                    </div>
                </div>
            </section>

            <FaqSection />
            <BookingCTA variant="dark" testid="booking-cta-services" />
        </>
    );
};

export default ServicesIndex;
